export enum TemplateHeaderTypes {
    Text = 'TEXT',
    Image = 'IMAGE',
    Document = 'DOCUMENT',
    Video = 'VIDEO'
}